import React from "react";

const QualityCheckLarge = ({ style }: { style?: React.CSSProperties }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 48 48"
      style={style}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M36.5 18c0 6.904-5.596 12.5-12.5 12.5S11.5 24.904 11.5 18 17.096 5.5 24 5.5 36.5 11.096 36.5 18zm1.5 0a13.95 13.95 0 01-3.65 9.427l4.942 8.56c.726 1.258-.31 2.803-1.75 2.608l-3.478-.469a.25.25 0 00-.265.153l-1.332 3.247c-.552 1.344-2.408 1.469-3.135.21l-5.502-9.53-5.502 9.53c-.727 1.259-2.583 1.134-3.135-.21l-1.332-3.247a.25.25 0 00-.265-.153l-3.478.47c-1.44.194-2.476-1.351-1.75-2.61l5.075-8.79A13.946 13.946 0 0110 18c0-7.732 6.268-14 14-14s14 6.268 14 14zM25.403 31.93a13.943 13.943 0 007.842-3.417l4.748 8.223a.25.25 0 01-.25.373l-3.478-.47a1.75 1.75 0 00-1.853 1.07l-1.333 3.247a.25.25 0 01-.448.03l-5.228-9.055zm-10.872-3.618l-4.863 8.424a.25.25 0 00.25.373l3.478-.47a1.75 1.75 0 011.852 1.07l1.333 3.247a.25.25 0 00.448.03l5.248-9.09a13.95 13.95 0 01-7.746-3.584zm9.944-16.871a.5.5 0 00-.95 0l-1.187 3.601a1 1 0 01-.95.688h-3.831a.5.5 0 00-.291.906l3.08 2.207a1 1 0 01.368 1.126l-1.179 3.576a.5.5 0 00.766.563l3.117-2.232a1 1 0 011.164 0l3.117 2.232a.5.5 0 00.766-.563l-1.18-3.576a1 1 0 01.368-1.127l3.081-2.206a.5.5 0 00-.29-.906h-3.832a1 1 0 01-.95-.688l-1.187-3.601z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};

export default QualityCheckLarge;
